import React from 'react';
import { Modal } from 'antd';
import { withCookies } from 'react-cookie';
import { getEshopData } from '../enums/fetchData';
import { navigate } from '@reach/router';


class ModalAge extends React.Component {
  state = { visible: false };

  componentDidMount() {
    const { cookies } = this.props
    if (cookies.get('confirmed18') === undefined) {
      this.setState({ visible: true })
    }
    if (cookies.get('confirmed18') === 'underage') {
      navigate('/underage')
    }

  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = e => {
    const { cookies } = this.props;
    cookies.set('confirmed18', 'seen', { maxAge: 60 * 60 * 24 });

    this.setState({
      visible: false,
    });
  };

  handleCancel = e => {
    const { cookies } = this.props

    console.log(e);
    cookies.set('confirmed18', 'underage', { maxAge: 60 * 60 * 24 });

    this.setState({
      visible: false,
    });
    navigate('/underage')
  };

  render() {
    return (
      <>
        <Modal
          title="Potvrďte věk "
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText="Potvrzuji věk a srozumění s pravidly"
        >
          <p>Pro vstup na eshop musíte splňovat podmínku zletilosti v ČR. Kliknutím potvrzujete, že vám bylo více než 18 let. </p>
          <p>Tímto eshopem vám chceme dát možnost si objednat naše pivo i s dovozem ve specifické dny. Jedná se o předobjednávku, kterou uhradíte při dovážce nebo převzetí v pivovaru</p>
          <p>Rozvážíme jen <strong>po Praze 5,6 a 7</strong>, a to zdarma, při objednávce nad {getEshopData().rules.minOrder} Kč. Podívejte se, prosím, na pravidla rozvozu v levé části.</p>
          {/* <p>Kompletní nabídku můžete také zakoupit na <strong>Křižíkově 17 v Karlíně</strong> ve spřáteleném <a href="https://pivo-klub.cz" target="_blank">Pivovarském klubu Benedict</a></p> */}
          <p>Všechny ceny jsou uvedeny včetně příslušného DPH.</p>
        </Modal>
      </>
    );
  }
}

export default withCookies(ModalAge)